export default __webpack_public_path__ + "static/media/services-icon2.b3bd382b.png";